import { render, staticRenderFns } from "./new_member.vue?vue&type=template&id=c59bcb46&"
import script from "./new_member.vue?vue&type=script&lang=js&"
export * from "./new_member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports